import { Component, inject } from '@angular/core';
import { ModuleManagerService } from '../../services/module-manager.service';
import { INavigationItem } from '../../model/i-navigation-item';
import { ModuleEntryPointDefinition } from '../../model/module-entry-point-definition';
import { MatMenuModule } from '@angular/material/menu';
import { ModuleIconComponent } from '../../components/module-icon/module-icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
   selector: 'asc-dashboard',
   templateUrl: './dashboard.component.html',
   styleUrls: ['./dashboard.component.scss'],
   imports: [
      CommonModule,
      MatButtonModule,
      MatMenuModule,
      MatTooltipModule,
      ModuleIconComponent
   ]
})
export class DashboardComponent {
   private moduleManagerService = inject(ModuleManagerService);


   public get featureNavigationItems(): INavigationItem[] {
      return this.moduleManagerService.featureNavigationItems || [];
   }

   public navigateTo(entryPoint: ModuleEntryPointDefinition) {
      if (entryPoint) {
         entryPoint.navigate();
      }
   }
}
